import { TabSwitcher } from '@aus-platform/design-system';
import { useAppSelector } from 'app/hooks';
import { isNil } from 'lodash';
import { selectMap3dDataset } from 'map-3d/shared/map-3d-slices';
import React, { useState } from 'react';
import { useDrillBlastRequestList } from 'shared/api/workspace';
import { Map3DNoTerrainSelected, Map3DNoAccessToFeature } from '../../shared';
import { drillAndBlastTabs } from './constants';
import { DrillAndBlastTabs } from './drill-and-blast-tabs';

export const DrillAndBlast: React.FC = () => {
  // Selectors.
  const { selectedTerrainIteration } = useAppSelector(selectMap3dDataset);

  // State.
  const [activeTabKey, setActiveTabKey] = useState(drillAndBlastTabs.Generate);

  // Prefetch history once terrain is selected (Generate form visible scenario).
  const { data: historyResponse } = useDrillBlastRequestList(
    selectedTerrainIteration?.id ?? null,
    !!selectedTerrainIteration?.id,
  );
  const historyItems = historyResponse?.data ?? [];

  // Handlers.
  const handleTabChange = (activeTabKey: string) => {
    setActiveTabKey(activeTabKey);
  };

  // Empty state when no terrain selected.
  if (isNil(selectedTerrainIteration?.id)) {
    return <Map3DNoTerrainSelected />;
  }

  // Empty state when no access to feature.
  if (!selectedTerrainIteration.canManageIterations) {
    return <Map3DNoAccessToFeature />;
  }

  // Render.
  return (
    <div className="drill-and-blast__container">
      <TabSwitcher
        tabComponentList={DrillAndBlastTabs({
          onClickGenerateFromHistory: () =>
            setActiveTabKey(drillAndBlastTabs.Generate),
          historyItems,
        })}
        activeKey={activeTabKey}
        onTabSwitch={handleTabChange}
      />
    </div>
  );
};
